import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'connected-react-router'

import { store, history } from './store'
// import registerServiceWorker from './utils/registerServiceWorker'
import { unregister } from './utils/registerServiceWorker'
import NavBar from './components/NavBar'
import Routes from './routes'
import './styles/core.css'
import { trackView } from './modules/analytics/analytics'
import { bugsnagClient } from './utils/bugsnag'

const ErrorBoundary = bugsnagClient.getPlugin('react')

class App extends React.Component {
  componentDidMount () {
    trackView({
      referrer: document.referrer,
      url: window.location.href
    })
  }

  render () {
    return (
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <div>
            <NavBar />
            <Routes />
          </div>
        </ConnectedRouter>
      </Provider>
    )
  }
}

unregister()
ReactDOM.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>,
  document.getElementById('root')
)
